var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block-editor attachment-input" },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("chatbotv2.blockAttachmentTriggerTitle"))),
      ]),
      _vm._v(" "),
      _c(
        "a-select",
        {
          staticClass: "select-filetype",
          attrs: { value: _vm.clone.fileType },
          on: {
            change: function (e) {
              return (_vm.clone.fileType = e)
            },
          },
        },
        [
          _c("a-select-option", { attrs: { value: "image" } }, [
            _vm._v(_vm._s(_vm.$t("chatbotv2.imageAttachment"))),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "audio" } }, [
            _vm._v(_vm._s(_vm.$t("chatbotv2.audioAttachment"))),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "video" } }, [
            _vm._v(_vm._s(_vm.$t("chatbotv2.videoAttachment"))),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "document" } }, [
            _vm._v(_vm._s(_vm.$t("chatbotv2.documentAttachment"))),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "any" } }, [
            _vm._v(_vm._s(_vm.$t("chatbotv2.anyAttachment"))),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "attribute-picker-section" },
        [
          _c("span", { staticClass: "sectionTitle" }, [
            _vm._v(
              _vm._s(_vm.$t("chatbotv2.blockAttachmentSaveUrlToAttribute"))
            ),
          ]),
          _vm._v(" "),
          _c(
            "a-popover",
            {
              attrs: {
                trigger: "click",
                overlayClassName: "no-padding",
                placement: "left",
              },
              model: {
                value: _vm.attributePickerVisible,
                callback: function ($$v) {
                  _vm.attributePickerVisible = $$v
                },
                expression: "attributePickerVisible",
              },
            },
            [
              _c(
                "div",
                { attrs: { slot: "content" }, slot: "content" },
                [
                  _c("AttributePicker", {
                    attrs: {
                      "default-selected": _vm.clone.alias,
                      pick: _vm.onAttributePicked,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "attribute-input" }, [
                _c("div", { staticClass: "attribute-input-text-wrapper" }, [
                  _vm.$_.isEmpty(_vm.clone.alias)
                    ? _c(
                        "div",
                        { staticClass: "attribute-input-placeholder" },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("chatbotv2.chooseAttributeType")) +
                              "\n                    "
                          ),
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "single-attribute-style",
                          class: { active: _vm.attributePickerVisible },
                        },
                        [
                          _c("AttributeIconPreview", {
                            attrs: { attribute: _vm.clone.alias },
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                ("" + _vm.clone.alias).startsWith("akinon_") ||
                                  _vm.Attributes.includes(_vm.clone.alias)
                                  ? _vm.$t("chatbotv2.attr." + _vm.clone.alias)
                                  : _vm.clone.alias
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                ]),
                _vm._v(" "),
                !_vm.$_.isEmpty(_vm.clone.alias)
                  ? _c("span", { staticClass: "material-icons" }, [
                      _vm._v(" expand_more "),
                    ])
                  : _vm._e(),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }